import React from 'react'

export const BgIcon = (props) => {
    return <div className="inv-bg-icon">
        {props.children}
    </div>
}

export const BgImage = (props) => {
    return <div className="bg-image" style={{
        backgroundImage: 'url(' + props.src + ')'
    }}>
        {props.children}
    </div>
}

